import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import SubmitButton from '../../components/Enter/fields/SubmitButton';
import EnterLayout from '../../components/layout/EnterLayout';

import FixelWatIcon from '../../../assets/icons/fixel-wat.svg';

import styles from './Restore.scss';

const RestoreRoute = () => {
  const intl = useIntl();

  return (
    <EnterLayout verticalPaddings={[0, 0]}>
      <div className={styles.wrapper}>
        <img
          src={FixelWatIcon}
          alt="Fixel the Cat saying 'Wat' and looking aside flabbergastedly"
          className={styles.fixelIcon}
          width="160"
          height="152"
        />

        <h3 className={styles.title}>
          <FormattedMessage
            id="accountRestore.title"
            defaultMessage="Wait a minute..."
            description={
              'Title of the page, that offers to recover a previously deleted account; ' +
              'User ends up here after trying to log in under a deleted account.'
            }
          />
        </h3>
        <span className={styles.text}>
          <FormattedMessage
            id="accountRestore.mainText"
            defaultMessage={
              'Looks like you already have an account, but it was deleted.' +
              ' \n ' +
              'You can restore it by contacting support or use other credentials instead.'
            }
            description={
              'Main text of the page, informing the user, that the account to login under has been deleted. ' +
              'Possible solutions is to contact support to restore it, or create a new account.'
            }
          />
        </span>

        <div className={styles.ctaWrapper}>
          <SubmitButton
            text={intl.formatMessage({
              id: 'accountRestore.ctaContactSupport',
              defaultMessage: 'Contact support',
              description: 'Main CTA of the form, clicking it opens up a support live chat pop-up',
            })}
            className={styles.contactSupport}
            onSubmit={() => window.Intercom('show')}
          />
          <a href="/enter" className={styles.otherLogin}>
            <FormattedMessage
              id="accountRestore.ctaBackToLogin"
              defaultMessage="Try other credentials"
              description="Secondary CTA, a link leading back to login page"
            />
          </a>
        </div>
      </div>
    </EnterLayout>
  );
};

export default RestoreRoute;
